// extracted by mini-css-extract-plugin
export var conversationListItem = "_x5-2";
export var fullBleedList = "_x5-3";
export var messageText = "_x5-1";
export var previewText = "_x5-0";